<p>connected-products works!</p>
